import React from 'react';

const StrategyTips = () => {
    const tips = [
      {
        icon: 'shield-alt',
        title: 'Avoid Detection',
        description: 'Use stealth mode and avoid rapid commands. Most anti-bot plugins detect unusual behavior patterns. Space out your attempts for better results.'
      },
      {
        icon: 'wrench',
        title: 'Target Vulnerabilities',
        description: 'Older server versions (1.8-1.12) are more vulnerable to console command exploits. Check server version before deploying.'
      },
      {
        icon: 'sync-alt',
        title: 'Rotate Methods',
        description: 'If one method fails, try different exploit methods. Common plugin vulnerabilities include Essentials, PermissionsEx, and LuckPerms misconfigurations.'
      }
    ];
  
    return (
      <div className="bg-dark-600 rounded-2xl p-6 transform-gpu hover:scale-[1.01] transition-medium border border-dark-400 hover:border-accent-yellow/30">
        {/* Background glow effects */}
        <div className="absolute -right-10 -top-10 w-32 h-32 bg-accent-yellow opacity-5 rounded-full blur-xl"></div>
        <div className="absolute -left-10 -bottom-10 w-32 h-32 bg-accent-orange opacity-5 rounded-full blur-xl"></div>
        
        <h3 className="font-bold text-lg mb-4 flex items-center group relative z-10">
          <div className="w-10 h-10 rounded-lg bg-accent-yellow/20 flex items-center justify-center mr-3 transform-gpu group-hover:rotate-12 transition-medium">
            <i className="fas fa-lightbulb text-accent-yellow"></i>
          </div> 
          Bot Strategy Tips
          <div className="ml-3 text-xs py-1 px-2 bg-accent-yellow/20 rounded-full text-accent-yellow opacity-0 group-hover:opacity-100 transition-medium">
            Pro Tips
          </div>
        </h3>
        
        <div className="space-y-4 relative z-10">
          {tips.map((tip, index) => (
            <div 
              key={index}
              className="flex p-3 bg-dark-500 rounded-lg hover:bg-dark-400 transition-medium transform-gpu hover:scale-[1.02] group"
            >
              <div className="w-8 h-8 rounded-lg bg-accent-yellow bg-opacity-20 flex items-center justify-center mr-3 flex-shrink-0 mt-1 transform-gpu group-hover:rotate-12 transition-medium">
                <i className={`fas fa-${tip.icon} text-accent-yellow text-sm`}></i>
              </div>
              <div>
                <p className="font-medium text-sm group-hover:text-white transition-medium">{tip.title}</p>
                <p className="text-xs text-gray-400 group-hover:text-gray-300 transition-medium">{tip.description}</p>
                <div className="mt-2 h-0.5 w-0 bg-accent-yellow group-hover:w-full transition-all duration-500 ease-out"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

export default StrategyTips;
